import React, { useState } from "react";
import { BsPlusLg } from "react-icons/bs";
import FileTag from "./FileTag";

const FileInputGallery = ({ item }) => {
  const {
    label,
    name,
    type,
    defaultValue,
    multiple,
    multipleData,
    fullCol,
    required,
    isGalleryFile,
  } = item;

  const [quantityCount, setCount] = useState(multipleData ? multipleData : []);
  const handleAddElement = () => {
    setCount((current) => [
      ...current,
      {
        label: label,
        type: "file",
        name: "",
        defaultValue: "",
      },
    ]);
  };
  return (
    <div
      className={
        fullCol
          ? "col-span-1 flex flex-row gap-4 md:items-end justify-start w-full items-center"
          : "col-span-1 lg:col-span-3 flex flex-col md:flex-row gap-4 md:items-end w-full items-center"
      }
    >
      <div
        className={
          fullCol
            ? "grid grid-cols-1 gap-x-4 gap-y-2 w-full"
            : "grid grid-cols-1 lg:grid-cols-6 lg:gap-x-8 gap-y-4 w-full"
        }
      >
        {multipleData ? (
          quantityCount.map((item, index) => (
            <FileTag
              key={index}
              label={label}
              length={index + 1}
              name={name}
              defaultValue={item.defaultValue}
              type={type}
              multiple={multiple}
              isGalleryFile={isGalleryFile}
            />
          ))
        ) : (
          <FileTag
            label={label}
            length={0}
            name={name}
            defaultValue={defaultValue}
            type={type}
            multiple={multiple}
            required={required}
            isGalleryFile={isGalleryFile}
          />
        )}
      </div>

      {multiple && (
        <div className="flex justify-center items-end">
          <button
            title="Add Image"
            onClick={handleAddElement}
            type="button"
            className="btn btn-circle border border-gray-400 rounded-full p-4 hover:bg-gray-50"
          >
            <BsPlusLg />
          </button>
        </div>
      )}
    </div>
  );
};

export default FileInputGallery;
